import { cn } from "@omni/utils/styles";
import { useState } from "react";
import { InView } from "react-intersection-observer";
import { useSelector } from "react-redux";

import { MiniCartComponent } from "@/components/Cart/MiniCart/miniCart.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import { TApiAction } from "@/redux/store.types";
import * as CartImpressionTracker from "@/services/tracking/trackers/impression/cartImpression.tracker";

export type MiniCartProps = {
    urlTarget?: string;
    isUpdatingCart?: { [key: string]: boolean };
    activeId: string;
    closeCallback?: () => void;
    removeFromCart?: (id: string, quantity: number, free: boolean) => void;
};

const MiniCart = ({
    urlTarget,
    isUpdatingCart,
    activeId,
    closeCallback,
    removeFromCart
}: MiniCartProps) => {
    const dispatch = useThunkDispatch();

    const [activated, setActivated] = useState(false);

    const cart = useSelector(CartSelectors.getCart);
    const cartLoading = useSelector(CartSelectors.isLoadingCart);

    const hasCartItems = (cart?.items || []).length > 0;

    const onInView = (inView: boolean) => {
        if (!inView) return;

        if (cart) {
            CartImpressionTracker.trackCart(cart);
        } else {
            dispatch(CartModule.load()).then(
                (action: TApiAction<CartModel>) => {
                    if (
                        action.type === CartModule.constants.SUCCESS &&
                        action.payload
                    ) {
                        CartImpressionTracker.trackCart(action.payload);
                    }
                }
            );
        }

        setActivated(true);
    };

    return (
        <InView
            className={cn(
                "tw:h-full tw:max-h-full! tw:flex tw:flex-col",
                "tw:lg:min-h-fit"
            )}
            triggerOnce={true}
            onChange={onInView}
        >
            {activated && (
                <MiniCartComponent
                    loading={cartLoading}
                    cart={cart}
                    hasCartItems={hasCartItems}
                    urlTarget={urlTarget}
                    isUpdatingCart={isUpdatingCart}
                    activeId={activeId}
                    removeFromCart={removeFromCart}
                    closeCallback={closeCallback}
                />
            )}
        </InView>
    );
};

export { MiniCart };
